import { render, staticRenderFns } from "./invoice.vue?vue&type=template&id=0df7ac9c&scoped=true"
import script from "./invoice.vue?vue&type=script&lang=ts"
export * from "./invoice.vue?vue&type=script&lang=ts"
import style0 from "./invoice.vue?vue&type=style&index=0&id=0df7ac9c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0df7ac9c",
  null
  
)

export default component.exports